import { render, staticRenderFns } from "./rate-table.vue?vue&type=template&id=512d73a2&scoped=true"
import script from "./rate-table.vue?vue&type=script&lang=js"
export * from "./rate-table.vue?vue&type=script&lang=js"
import style0 from "./rate-table.vue?vue&type=style&index=0&id=512d73a2&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "512d73a2",
  null
  
)

export default component.exports